import { render, staticRenderFns } from "./CustomizationSetting.vue?vue&type=template&id=e8841734&"
import script from "./CustomizationSetting.vue?vue&type=script&lang=js&"
export * from "./CustomizationSetting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Volumes/Development/2020/invoicing/crater-20201222/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e8841734')) {
      api.createRecord('e8841734', component.options)
    } else {
      api.reload('e8841734', component.options)
    }
    module.hot.accept("./CustomizationSetting.vue?vue&type=template&id=e8841734&", function () {
      api.rerender('e8841734', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/views/settings/CustomizationSetting.vue"
export default component.exports